<template>
  <div class="faq__accordion-item">
    <div class="faq__accordion-header" :aria-expanded="expanded" @click="toggleExpanded()">
      <div class="faq__accordion-title">
        <slot name="header"></slot>
      </div>
      <span class="icon" :aria-hidden="!expanded">
        <i></i>
        <i></i>
      </span>
    </div>
    <transition name="fade">
      <div class="faq__accordion-content" v-if="expanded">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LandingFaqItem',
  data () {
    return {
      expanded: false,
      hidden: true,
      timer: null
    }
  },
  methods: {
    toggleExpanded () {
      this.expanded = !this.expanded
      this.$emit('clickHeaderFaq', this.expanded)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    opacity: 1;
    max-height: fit-content;
    transition: all 200ms linear, max-height 200ms linear;
    will-change: opacity, max-height;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 200ms linear, max-height 200ms linear;
    will-change: opacity, max-height;
  }
  .accordion-item-show{
    transition: all 100ms linear;
  }
</style>
